import { render, staticRenderFns } from "./CalculatedField.vue?vue&type=template&id=8dc7f4e4&lang=pug&"
import script from "./CalculatedField.vue?vue&type=script&lang=js&"
export * from "./CalculatedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc7f4e4')) {
      api.createRecord('8dc7f4e4', component.options)
    } else {
      api.reload('8dc7f4e4', component.options)
    }
    module.hot.accept("./CalculatedField.vue?vue&type=template&id=8dc7f4e4&lang=pug&", function () {
      api.rerender('8dc7f4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/CalculatedField.vue"
export default component.exports